import { render, staticRenderFns } from "./subForm.vue?vue&type=template&id=2e42ee7c&scoped=true&"
import script from "./subForm.vue?vue&type=script&lang=js&"
export * from "./subForm.vue?vue&type=script&lang=js&"
import style0 from "./subForm.vue?vue&type=style&index=0&id=2e42ee7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42ee7c",
  null
  
)

export default component.exports